import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Loader } from '../components/Loader';
import { Error } from '../components/Error';

import { TransitionWrapper } from '../components/TransitionWrapper';
import PostArticle from '../components/PostArticle';

const GET_POST_PAGE = gql`
  query getPostPage($id: Int!) {
    post: getWPPost(id: $id) {
      id
      title {
        rendered
      }
      excerpt {
        rendered
      }
      content {
        rendered
      }
      embedded {
        featuredmedia {
          media_details {
            file
          }
        }
      }
      acf
    }
  }
`;

export default function PostPage({ postId }) {
  return (
    <TransitionWrapper>
      <Query query={GET_POST_PAGE} variables={{ id: Number(postId) }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }

          if (error) {
            return <Error error={error} />;
          }

          if (!data.post || !data.post.id) {
            //@todo: Redirect to 404
            return <div>Ikke funnet</div>;
          }

          return <PostArticle post={data.post} />;
        }}
      </Query>
    </TransitionWrapper>
  );
}

PostPage.propTypes = {
  postId: PropTypes.string.isRequired
};
